import { toast } from "react-toastify";
import extracerForValidations from "../extractors/extracerForValidations";
import getFieldAddressAfterIndex from "../extractors/getFieldAddressAfterIndex";
import updateNestedField from "./updateNestedField";
import validate from "./validateV2";

const keepValidatingInSetState = ({
  newFormValidity,
  data,
  cleanAddressForExtracer,
  validateAttributes,
  qqqq,
}) => {
  if (qqqq === "qqqq") {
    console.log("data", data);
    console.log("cleanAddressForExtracer", cleanAddressForExtracer);
    console.log("validateAttributes", validateAttributes);
    console.log("newFormValidity", newFormValidity);
  }
  if (cleanAddressForExtracer) {
    if (Array.isArray(cleanAddressForExtracer)) {
      for (const eachCleanAddressForExtracer of cleanAddressForExtracer) {
        const {
          value: extractedData,
          isComplete,
          processedPath,
        } = extracerForValidations(data, eachCleanAddressForExtracer);

        if (Array.isArray(extractedData) && !isComplete) {
          for (let i = 0; i < extractedData.length; i++) {
            const { value: newFormValidityUntillHere } = extracerForValidations(
              newFormValidity,
              eachCleanAddressForExtracer
              // "tttt"
            );
            const newAddressForExtracer = getFieldAddressAfterIndex(eachCleanAddressForExtracer, 0);
            keepValidatingInSetState({
              newFormValidity: newFormValidityUntillHere[i],
              data: extractedData[i],
              cleanAddressForExtracer: newAddressForExtracer,
              validateAttributes,
              qqqq,
            });
          }
        } else if (Array.isArray(extractedData) && isComplete) {
          let validateOptions = {
            data: extractedData,
            ...validateAttributes,
          };
          validateOptions.type = "atLeastOneItemEvenEmpty";
          const validateRes = validate(validateOptions);
          if (!validateRes?.isValid) {
            const updatedprocessedPath = [
              ...processedPath.slice(0, -1), // All items except the last
              `${processedPath[processedPath.length - 1]}Container`, // Append to the last item
            ];
            updateNestedField(newFormValidity, updatedprocessedPath, validateRes);
            console.log(
              "false validation founded ,",
              "at : ",
              cleanAddressForExtracer,
              "and eachCleanAddressForExtracer",
              eachCleanAddressForExtracer,
              "validateRes : ",
              validateRes,
              "extractedData",
              extractedData,
              "validateAttributes",
              validateAttributes
            );
          }
        } else {
          const validateRes = validate({
            data: extractedData,
            // type: eachFieldValidation.validationType,
            // forceLtr,
            // isOptional: eachFieldValidation.isMandatory === true ? false : true,
            ...validateAttributes,
          });
          if (!validateRes?.isValid) {
            console.log(
              "false validation founded ,",
              "at : ",
              cleanAddressForExtracer,
              "and eachCleanAddressForExtracer",
              eachCleanAddressForExtracer,
              "validateRes : ",
              validateRes,
              "extractedData",
              extractedData,
              "validateAttributes",
              validateAttributes
            );
          }
          updateNestedField(newFormValidity, processedPath, validateRes);
        }
      }
    } else {
      const {
        value: extractedData,
        isComplete,
        processedPath,
      } = extracerForValidations(data, cleanAddressForExtracer);
      if (qqqq === "qqqq") {
        // console.log("extractedData", extractedData);
        // console.log("isComplete", isComplete);
      }
      if (Array.isArray(extractedData) && !isComplete) {
        for (let i = 0; i < extractedData.length; i++) {
          const { value: newFormValidityUntillHere } = extracerForValidations(
            newFormValidity,
            cleanAddressForExtracer
            // "tttt"
          );
          const newAddressForExtracer = getFieldAddressAfterIndex(cleanAddressForExtracer, 0);
          keepValidatingInSetState({
            newFormValidity: newFormValidityUntillHere[i],
            data: extractedData[i],
            cleanAddressForExtracer: newAddressForExtracer,
            validateAttributes,
            qqqq,
          });
        }
      } else if (Array.isArray(extractedData) && isComplete) {
        let validateOptions = {
          data: extractedData,
          ...validateAttributes,
        };
        validateOptions.type = "atLeastOneItemEvenEmpty";
        const validateRes = validate(validateOptions);
        if (!validateRes?.isValid) {
          const updatedprocessedPath = [
            ...processedPath.slice(0, -1), // All items except the last
            `${processedPath[processedPath.length - 1]}Container`, // Append to the last item
          ];
          updateNestedField(newFormValidity, updatedprocessedPath, validateRes);
          console.log(
            "false validation founded ,",
            "at : ",
            cleanAddressForExtracer,
            "validateRes : ",
            validateRes,
            "extractedData",
            extractedData,
            "validateAttributes",
            validateAttributes
          );
        }
      } else {
        const validateRes = validate({
          data: extractedData,
          // type: eachFieldValidation.validationType,
          // forceLtr,
          // isOptional: eachFieldValidation.isMandatory === true ? false : true,
          ...validateAttributes,
        });
        if (!validateRes?.isValid) {
          console.log(
            "false validation founded ,",
            "at : ",
            cleanAddressForExtracer,
            "validateRes : ",
            validateRes,
            "extractedData",
            extractedData,
            "validateAttributes",
            validateAttributes
          );
        }
        updateNestedField(newFormValidity, processedPath, validateRes);
      }
    }
  } else {
    toast.error("Report this to PNG , cleanAddressForExtracer not founded", {
      toastId: "cleanAddressForExtracer",
    });
  }
};

export default keepValidatingInSetState;
